import { type Entity } from '@backstage/catalog-model';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

const isDefaultEntityKind = (entity: Entity) => {
  const kind = entity.kind.toLocaleLowerCase('en-US');

  return !['api', 'group', 'user', 'system', 'domain'].includes(kind);
};

const readmeEntityContent = EntityContentBlueprint.make({
  name: 'driveline-readme',
  params: {
    path: '/readme',
    title: 'Readme',
    filter: isDefaultEntityKind,
    loader: () =>
      import('./ReadmeEntityContent').then(module => (
        <module.ReadmeEntityContent />
      )),
  },
});

export const readmeEntityContentModule = createFrontendModule({
  pluginId: 'readme',
  extensions: [readmeEntityContent],
});
